import { supabase } from './supabase';

export type TrainingRegistrationWithProfile = {
  id: string;
  training_id: string;
  training_title: string | null;
  user_id: string;
  full_name: string | null;
  nickname: string | null;
  email: string | null;
  registration_status: string;
  payment_status: string;
  payment_amount: number | null;
  payment_date: string | null;
  reservation_expires_at: string | null;
  waitlist_position: number | null;
  waitlist_joined_at: string | null;
  created_at: string;
};

export async function getTrainingRegistrationsWithProfiles(trainingId: string): Promise<{
  success: boolean;
  data?: TrainingRegistrationWithProfile[];
  error?: string;
}> {
  try {
    const { data, error } = await supabase
      .from('training_registrations_with_profiles')
      .select(
        `
        id,
        training_id,
        training_title,
        user_id,
        full_name,
        nickname,
        email,
        registration_status,
        payment_status,
        payment_amount,
        payment_date,
        reservation_expires_at,
        waitlist_position,
        waitlist_joined_at,
        created_at
      `
      )
      .eq('training_id', trainingId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return { success: true, data: (data || []) as any };
  } catch (e: any) {
    console.error('[getTrainingRegistrationsWithProfiles] error:', e);
    return { success: false, error: e?.message || 'Błąd pobierania rezerwacji' };
  }
}


